import Global from "../Common/Global";
import Commons from "../Common/Common";
import IndexedDb from "../IndexedDb/IndexedDb";

const EmployeeService = {
  // 사용자 정보 업데이트
  upsertEmployee: async ({ tel, email, photoUrl, concent } = {}) => {
    const userInfo = await IndexedDb.GetUserInfo();
    const empId = userInfo?.userId || userInfo?.userid || userInfo?.empId;
    if (!empId) {
      throw new Error("empId가 없습니다.");
    }

    const payload = {
      empId: empId,
      email: email !== undefined ? email : userInfo?.email || userInfo?.eMail || "",
      tel: tel !== undefined ? tel : userInfo?.tel || "",
      concent: typeof concent === "boolean" ? concent : false,
      photoUrl: photoUrl !== undefined ? photoUrl : userInfo?.photoUrl || userInfo?.profileImage || "",
    };

    return Commons.Axios("post", Global.base.useUrl + Global.urls.Employee.Upsert, {}, payload);
  },
  
  // 업데이트 후 IndexedDb 동기화
  upsertAndSync: async (update = {}) => {
    const response = await EmployeeService.upsertEmployee(update);
    const ok = response && response.status === 200;
    if (ok) {
      const updateForIndexedDb = { ...update };
      if (Object.prototype.hasOwnProperty.call(updateForIndexedDb, "photoUrl") && !Object.prototype.hasOwnProperty.call(updateForIndexedDb, "profileImage")) {
        updateForIndexedDb.profileImage = updateForIndexedDb.photoUrl;
      }
      if (Object.prototype.hasOwnProperty.call(updateForIndexedDb, "email") && !Object.prototype.hasOwnProperty.call(updateForIndexedDb, "eMail")) {
        updateForIndexedDb.eMail = updateForIndexedDb.email;
      }
      await IndexedDb.UpdateUserInfo(updateForIndexedDb);
    }
    return response;
  },
};

export default EmployeeService;